

































































import Vue from "vue";
import { Component, Ref } from "vue-property-decorator";
import Header from "@/models/header";
// @ts-ignore
import { TrashIcon } from "vue-feather-icons";
import { mapGetters, mapState } from "vuex";
import * as _ from "lodash";

@Component({
  computed: {
    ...mapState("headers", ["headers", "predefinedHeaderKeys"]),
    ...mapGetters("subscriptions", ["hasActiveSubscription"]),
  },
  components: {
    TrashIcon,
  },
})
export default class SettingsHeaders extends Vue {
  // mapState + mapGetters
  headers!: Array<Header>;
  predefinedHeaderKeys!: { key: string }[];
  hasActiveSubscription!: boolean;

  item = "";
  localHeaders: Array<Header> = [];
  loading = false;

  @Ref("newKey")
  newKey!: any;

  mounted() {
    this.loading = true;

    this.$store.dispatch("headers/get").then(() => {
      // @ts-ignore
      this.localHeaders = _.clone(this.headers);
      this.loading = false;
      this.addEmptyHeader();
    });
  }

  querySearch(queryString: string, cb: any) {
    const headers = this.predefinedHeaderKeys;
    const results = queryString
      ? headers.filter(this.createFilter(queryString))
      : headers;
    // call callback function to return suggestions
    cb(results);
  }

  createFilter(queryString: string) {
    return (header: any) => {
      return header.key.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
    };
  }

  addEmptyHeader() {
    const header = new Header({ key: "", value: "" });
    this.localHeaders.push(header);
  }

  askDeleteHeader(id: string) {
    this.$confirm(
      `Are you sure you want to delete this header?`,
      "Delete header",
      {
        confirmButtonText: "Yes, delete",
        cancelButtonText: "Cancel",
        type: "warning",
      }
    )
      .then(() => {
        this.deleteHeader(id);
      })
      .catch(() => {
        return;
      });
  }

  deleteHeader(id: string) {
    const localHeader = this.localHeaders.find((h) => h.id === id);
    if (localHeader == null) {
      return;
    }
    //
    // If the header is not in the store: it was freshly added
    const header = this.headers.find((h) => h.id == id);
    if (header == null) {
      const index = this.localHeaders.findIndex((lh) => lh.id === id);
      if (index > -1) {
        this.localHeaders.splice(index, 1);
      }
      return;
    }

    this.$store.dispatch("headers/delete", id).then(() => {
      const index = this.localHeaders.findIndex((lc) => lc.id === id);
      if (index > -1) {
        this.localHeaders.splice(index, 1);
      }
    });
  }

  setFocus() {
    this.$nextTick(() => {
      if (this.newKey) {
        this.newKey.focus();
      }
    });
  }

  updateHeader(payload: Header) {
    const header = this.localHeaders.find((lh) => lh.id === payload.id);

    if (!header) {
      return;
    }
    //
    // If this header is the last one
    // add a new empty header
    const index = this.localHeaders.indexOf(header);
    if (index === this.localHeaders.length - 1) {
      this.addEmptyHeader();
    }
    // Update the header
    header.key = payload.key;
    header.value = payload.value;
  }

  saveHeaders() {
    this.loading = true;
    //
    // Only get the valid headers
    const validHeaders: Array<Header> = this.localHeaders.filter(
      (h) => !h.isEmpty
    );
    //
    // Update the headers
    this.$store.dispatch("headers/update", validHeaders).then(() => {
      this.loading = false;
    });
  }

  handleClose() {
    this.$emit("close");
  }
}
